export default {
  title: 'Varaukset CSV',
  buttons: {
    generate: 'Luo ja lataa',
  },
  fields: {
    date_range: 'Aikaväli (valinnainen)',
  },
  errors: {
    invalid_date_range: 'Valitse kelvollinen aikaväli',
  },
};
